import { a as e, c as t, i as n, l as r, o as i, r as a, s as o, u as s } from "./gallery-preview-carousel-Col7B2hH.js";
import { n as c, r as l, t as u } from "./gallery-list.selector-t3NALU34.js";
import { t as d } from "./gallery-related-gallery-CZWoYo0l.js";
import { defineAsyncComponent as f } from "vue";
import { ROUTES as p, getI18n as m } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var h = {
	en: {
		gallery: {
			title: "Main headline",
			kicker: "Kicker",
			seoTitle: "SEO headline",
			leadText: "Lead text",
			relatedGalleries: "Linked galleries",
			linkGallery: "Link gallery",
			addSelected: "Add selected galleries",
			license: "License",
			publishedAt: "Publish date",
			expiredAt: "Unpublish date",
			savePublish: "Publish",
			saveScheduled: "Schedule publication",
			adsEnabled: "Activate ads",
			adTags: "Ad tags",
			messageMandatoryInformation: "The gallery cannot be saved because mandatory information is missing.",
			saveDraft: "Save as draft",
			saveOffline: "Unpublish",
			modeUnpublished: "Gallery unpublished",
			modeScheduled: "Publication date scheduled",
			modePublished: "Published",
			modeDraft: "Draft",
			errorFailedLoadedGalleryWithId: "The gallery with UUID {id} could not be found.",
			messageSaved: "Gallery saved",
			messageEdited: "Gallery edited",
			messageDeleted: "Gallery deleted",
			messageDeleteGallery: "Are you sure you want to delete this gallery?",
			messageDeleteGalleryTitle: "Delete gallery",
			messageConfirmUnpublishGallery: "Are you sure you want to take the gallery offline?",
			messageUnpublishGalleryTitle: "Unpublish gallery",
			messageConfirmDraftGallery: "Are you sure you want to set the gallery to draft?",
			messagePublishTitle: "Publish gallery",
			messagePublish: "Are you sure you want to publish this gallery?",
			messageRepublishInFutureTitle: "Reschedule publishing",
			messageRepublishInFuture: "Are you sure you want to take the gallery offline and schedule it to be published in the future?",
			addImage: "Add image",
			errorOnDeleting: "Error deleting the gallery",
			noEditTooltip: "This gallery is originally from {source} editor.",
			toGallery: "To gallery",
			pathAutogenerate: "Automatically generate path",
			invalidOrigin: "The image credit cannot be Xymatic.",
			handledInLegacySystem: "This gallery is being handled in {source}. It cannot be edited in Vibe.",
			requiredFields: "The gallery cannot be saved because mandatory information is missing.",
			contentBlockLabel: "Gallery",
			embeddedGalleryInlineRendered: {
				label: "Render as embedded gallery",
				description: "Display gallery images inline within the content"
			},
			embeddedGalleryOffset: {
				title: "Image range (optional)",
				description: "Show only specific images from this gallery",
				startOffset: "Start image",
				endOffset: "End image",
				startPlaceholder: "1st image",
				endPlaceholder: "Last image",
				validation: {
					startMinimum: "The number of the start image must be at least 1.",
					startExceedsTotal: "The number of the start image cannot  exceed the total number of ({total}).",
					startMustBeLessThanEnd: "The number of the start image cannot be higher than the number of the end image.",
					endExceedsTotal: "The number of the end image may not exceed the total number of images  ({total}) in the gallery.",
					endMustBeGreaterThanStart: "The number of the end image cannot be smaller than the number of the start image."
				}
			},
			router: {
				createGallery: "Create gallery",
				editGallery: "Edit gallery"
			},
			feedSettings: {
				title: "Feeds",
				description: "The gallery will be included in the following feeds:",
				options: {
					include: "Yes",
					exclude: "No"
				}
			}
		},
		galleryList: {
			gallerySearch: "Search for kicker or main headline",
			state: "Status",
			galleryTitle: "Kicker, main headline",
			galleryOfDay: "Gallery of the day",
			newGallery: "New gallery",
			images: "Images",
			preview: "Preview",
			editGallery: "Edit",
			viewGallery: "View",
			deleteGallery: "Delete",
			useGalleryOfDay: "Use as gallery of the day",
			removeGalleryOfDay: "Do not use as gallery of the day",
			searchByBrand: "Search for brand",
			galleryLabel: "Select or upload gallery",
			remove: "Remove",
			edit: "Edit",
			brand: "Brand",
			showPartnerGalleries: "Show partner galleries",
			partnerGalleryBadge: "Partner gallery"
		},
		states: {
			galleryDraft: "Draft",
			galleryPublish: "Online in {n} days",
			galleryExpiresIn: "Expires in {n} days",
			galleryExpired: "Unpublished"
		}
	},
	de: {
		gallery: {
			title: "Hauptzeile",
			kicker: "Vorzeile",
			seoTitle: "SEO-Überschrift",
			leadText: "Vorspann",
			relatedGalleries: "Verlinkte Galerien",
			linkGallery: "Galerie verlinken",
			addSelected: "Ausgewählte Galerien hinzufügen",
			license: "Lizenz",
			publishedAt: "Veröffentlichungsdatum",
			expiredAt: "Ablaufdatum",
			savePublish: "Veröffentlichen",
			saveScheduled: "Veröffentlichung planen",
			adsEnabled: "Werbung aktivieren",
			adTags: "Werbe-Tags",
			messageMandatoryInformation: "Die Galerie kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			saveDraft: "Als Entwurf speichern",
			saveOffline: "Depublizieren",
			modeUnpublished: "Galerie depubliziert",
			modeScheduled: "Veröffentlichungsdatum gesetzt",
			modePublished: "Veröffentlicht",
			modeDraft: "Entwurf",
			errorFailedLoadedGalleryWithId: "Die Galerie mit der UUID {id} wurde nicht gefunden.",
			messageSaved: "Galerie gespeichert",
			messageEdited: "Galerie bearbeitet",
			messageDeleted: "Galerie gelöscht",
			messageDeleteGallery: "Willst du diese Galerie wirklich löschen?",
			messageDeleteGalleryTitle: "Galerie löschen",
			messageConfirmUnpublishGallery: "Willst du die Galerie wirklich depublizieren?",
			messageUnpublishGalleryTitle: "Galerie depublizieren",
			messageConfirmDraftGallery: "Willst du die Galerie wirklich als Entwurf speichern?",
			messagePublishTitle: "Galerie veröffentlichen",
			messagePublish: "Willst du diese Galerie wirklich veröffentlichen?",
			messageRepublishInFutureTitle: "Veröffentlichung verschieben",
			messageRepublishInFuture: "Willst du die Galerie wirklich offline nehmen und eine spätere Wieder-Veröffentlichung planen?",
			addImage: "Bild hinzufügen",
			errorOnDeleting: "Fehler beim Löschen der Galerie",
			noEditTooltip: "Diese Galerie stammt ursprünglich aus dem {source}-Editor.",
			toGallery: "Zur Galerie",
			pathAutogenerate: "Pfad automatisch generieren",
			invalidOrigin: "Der Bild-Credit darf nicht Xymatic sein.",
			handledInLegacySystem: "Diese Galerie wird in {source} verwaltet und kann nicht in Vibe bearbeitet werden.",
			requiredFields: "Die Galerie kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
			contentBlockLabel: "Galerie",
			embeddedGalleryInlineRendered: {
				label: "Als Embed-Galerie anzeigen",
				description: "Galeriebilder inline im Inhalt anzeigen"
			},
			embeddedGalleryOffset: {
				title: "Bildbereich (optional)",
				description: "Nur bestimmte Bilder aus dieser Galerie anzeigen",
				startOffset: "Startbild",
				endOffset: "Endbild",
				startPlaceholder: "1 (erstes Bild)",
				endPlaceholder: "Letztes Bild",
				validation: {
					startMinimum: "Die Nummer des Startbildes muss mindestens 1 sein.",
					startExceedsTotal: "Die Nummer des Startbildes kann nicht größer als die Gesamtzahl von ({total}) sein.",
					startMustBeLessThanEnd: "Die Nummer des Startbildes darf nicht größer als die des Endbildes sein.",
					endExceedsTotal: "Die Nummer des Endbildes darf nicht höher sein als die Gesamtzahl der Bilder ({total}) in der Galerie.",
					endMustBeGreaterThanStart: "Die Nummer des Endbildes darf nicht kleiner als die des Startbildes sein."
				}
			},
			router: {
				createGallery: "Galerie erstellen",
				editGallery: "Galerie bearbeiten"
			},
			feedSettings: {
				title: "Feeds",
				description: "Die Galerie erscheint in folgenden Feeds:",
				options: {
					include: "Ja",
					exclude: "Nein"
				}
			}
		},
		galleryList: {
			gallerySearch: "Suchen nach Vorzeile oder Hauptzeile",
			state: "Status",
			galleryTitle: "Vorzeile, Hauptzeile",
			galleryOfDay: "Galerie des Tages",
			newGallery: "Neue Galerie",
			images: "Bilder",
			preview: "Vorschau",
			editGallery: "Bearbeiten",
			viewGallery: "Anzeigen",
			deleteGallery: "Löschen",
			useGalleryOfDay: "Als Galerie des Tages verwenden",
			removeGalleryOfDay: "Nicht mehr als Galerie des Tages verwenden",
			searchByBrand: "Suchen nach Marke",
			galleryLabel: "Galerie auswählen oder hochladen",
			remove: "Entfernen",
			edit: "Bearbeiten",
			brand: "Marke",
			showPartnerGalleries: "Partner-Galerien anzeigen",
			partnerGalleryBadge: "Partner-Galerie"
		},
		states: {
			galleryDraft: "Entwurf",
			galleryPublish: "Online in {n} Tagen",
			galleryExpiresIn: "Läuft in {n} Tagen ab",
			galleryExpired: "Depubliziert"
		}
	}
}, g = [{
	path: `/${p.galleries.path}`,
	meta: { i18RouteTitleKey: p.galleries.path },
	children: [
		{
			path: "",
			name: "gallery_list",
			component: () => import("./gallery-list-BgzVi6ma.js"),
			meta: { requiredRight: "galleries:navigate" }
		},
		{
			path: "new",
			name: "gallery_new",
			component: () => import("./gallery-edit-rvMEELrv.js"),
			props: () => ({
				title: m().t("gallery.router.createGallery"),
				backRoute: "/galleries"
			}),
			meta: { requiredRight: "galleries:navigate" }
		},
		{
			path: ":id",
			name: "gallery_detail",
			component: () => import("./gallery-edit-rvMEELrv.js"),
			props: (e) => ({
				title: m().t("gallery.router.editGallery"),
				id: e.params.id,
				backRoute: "/galleries"
			}),
			meta: { requiredRight: "galleries:navigate" }
		}
	]
}], _ = f(() => import("./gallery-content-block-C9c2X9f1.js")), v = {
	messages: h,
	routes: g,
	contentBlocks: [{
		type: "GALLERY",
		label: "gallery.contentBlockLabel",
		icon: "gallery",
		component: _,
		defaultValue: o()
	}]
};
//#endregion
export { _ as GalleryContentBlock, u as GalleryListSelector, a as GalleryModelName, d as GalleryRelatedGallery, n as GalleryService, c as OnGalleryUpdatedEvent, e as deleteGallery, i as editGallery, v as galleryModule, o as getDefaultGalleryBlock, t as getGalleries, r as getGallery, l as onGalleryUpdatedEventType, s as postGallery };

//# sourceMappingURL=index.es.js.map